import { useEffect, useState } from "react";
// #1638's ScoreboardFrame.jsx already established the pattern this follows:
// import the raw-src subpath (common-fe/venueTime), never the package root,
// so a public-board route never drags react-oidc-context/CognitoAuthProvider
// into its main chunk. formatVenueTime is also the SAME formatter the
// "as of X venue time" staleness footer already uses (#1637) -- card #1692's
// whole premise is that venue-local time is already available to the page
// through this module, so this reuses it rather than introducing a second
// timezone source.
import { formatVenueTime, DEFAULT_VENUE_TIMEZONE } from "common-fe/venueTime";
import { useVenueTimeZone } from "./VenueTimeZoneContext";
import "./VenueClock.css";

// Card #1692 -- the always-present venue wall clock (bottom-right, every mode
// type/layout family, seconds, once-a-second tick). `venueClockText` is
// exported on its own, separate from the ticking React component below, so
// #1692 AC4's test can pin a fixed instant + timezone and assert the exact
// string this component would render WITHOUT mounting React -- it is the one
// place this component decides what string to show, so pinning it here pins
// the component's real behavior, not a duplicate of it.
export function venueClockText(date, timeZone = DEFAULT_VENUE_TIMEZONE) {
  return formatVenueTime(date, { timeZone, seconds: true });
}

// Ticks once a second so the seconds digit stays live -- React does not
// re-render on the passage of time by itself (same rationale as
// ScoreboardFrame's useElapsedMs, #1637).
export default function VenueClock() {
  const [now, setNow] = useState(() => new Date());
  // #1788 — the show's zone, from context. This component sits in
  // ScoreboardFrame's bottom-right slot and is passed no props at all, which
  // is exactly why the zone travels by context rather than as a prop.
  const timeZone = useVenueTimeZone();

  useEffect(() => {
    const id = setInterval(() => setNow(new Date()), 1000);
    return () => clearInterval(id);
  }, []);

  // Plain text in a positioned container -- no button, no link, no
  // tabIndex, no interactive role, no onClick. #1691's
  // scoreboard-no-interactive.cy.js spec asserts the whole board has zero
  // focusable/interactive elements; this clock must never be the thing that
  // reintroduces one.
  return (
    <div className="venue-clock" data-testid="venue-clock">
      {venueClockText(now, timeZone)}
    </div>
  );
}
